import { createAction } from 'redux-actions';

export const GET_LISTS = createAction('GET_LISTS');
export const GET_LISTS_START = createAction('GET_LISTS_START');
export const GET_LISTS_SUCCESS = createAction('GET_LISTS_SUCCESS');
export const GET_LISTS_ERROR = createAction('GET_LISTS_ERROR');
export const GET_LISTS_FINALLY = createAction('GET_LISTS_FINALLY');
export const MERGE_CONTINUE_WATCHING_LISTS = createAction('MERGE_CONTINUE_WATCHING_LISTS');